module.exports = __webpack_public_path__ + "media/images/icons/outlined/check-circle-73dcbe9abfaed88381ace8173eadc11c.svg";